import script from "./Netherland.vue?vue&type=script&setup=true&lang=js"
export * from "./Netherland.vue?vue&type=script&setup=true&lang=js"

import "./Netherland.vue?vue&type=style&index=0&id=08fc125b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08fc125b"]])

export default __exports__